import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addBettingMarketMapping } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";
import { AddBettingMarketMappingParams } from "@/types/ApiResponses/BettingMarket";

export const useAddBettingMarketMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddBettingMarketMappingParams) => addBettingMarketMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [BettingMarketsQueryKeys.BettingMarketMappings, variables.marketId],
      });
    },
  });
};
